import { render } from "./TicketResolveOTP.vue?vue&type=template&id=5e336c52&scoped=true"
import script from "./TicketResolveOTP.vue?vue&type=script&lang=js"
export * from "./TicketResolveOTP.vue?vue&type=script&lang=js"

import "./TicketResolveOTP.vue?vue&type=style&index=0&id=5e336c52&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e336c52"]])

export default __exports__